import request from '../utils/request'

export const login = (data) => request.post('/auth/login', data)
export const getCaptcha = () => request.get('/auth/captcha')
export const getUserInfo = () => request.get('/auth/info')
export const logout = () => request.post('/auth/logout')

export const getMaterialTypeTree = () => request.get('/materialType/tree')
export const getMaterialTypeList = () => request.get('/materialType/list')
export const addMaterialType = (data) => request.post('/materialType', data)
export const updateMaterialType = (data) => request.put('/materialType', data)
export const deleteMaterialType = (id) => request.delete(`/materialType/${id}`)

export const getWarehousePage = (params) => request.get('/warehouse/page', { params })
export const getWarehouseList = () => request.get('/warehouse/list')
export const addWarehouse = (data) => request.post('/warehouse', data)
export const updateWarehouse = (data) => request.put('/warehouse', data)
export const deleteWarehouse = (id) => request.delete(`/warehouse/${id}`)

export const getStorageLocationList = (warehouseId) => request.get('/storageLocation/list', { params: { warehouseId } })
export const addStorageLocation = (data) => request.post('/storageLocation', data)
export const updateStorageLocation = (data) => request.put('/storageLocation', data)
export const deleteStorageLocation = (id) => request.delete(`/storageLocation/${id}`)

export const getMaterialPage = (params) => request.get('/material/page', { params })
export const getMaterialList = () => request.get('/material/list')
export const getMaterialById = (id) => request.get(`/material/${id}`)
export const addMaterial = (data) => request.post('/material', data)
export const updateMaterial = (data) => request.put('/material', data)
export const deleteMaterial = (id) => request.delete(`/material/${id}`)
export const exportMaterialHandheldMap = () => request.get('/material/export-handheld', { responseType: 'blob' })
export const exportRfidMasterData = () => request.get('/rfid/scan/master-data/export', { responseType: 'blob' })
export const parseRfidHandheldExport = (file, expectedBizType) => {
  const formData = new FormData()
  formData.append('file', file)
  const q = expectedBizType ? `?expectedBizType=${encodeURIComponent(expectedBizType)}` : ''
  return request.post(`/rfid/scan/parse-export${q}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000
  })
}

export const getMaterialTemplateByType = (typeId) => request.get(`/materialTemplate/byType/${typeId}`)
export const getMaterialTemplateById = (id) => request.get(`/materialTemplate/${id}`)
export const saveMaterialTemplate = (data) => request.post('/materialTemplate', data)
export const updateMaterialTemplate = (data) => request.put('/materialTemplate', data)
export const deleteMaterialTemplateByType = (typeId) => request.delete(`/materialTemplate/byType/${typeId}`)

export const getStockPage = (params) => request.get('/stock/page', { params })
export const getStockByMaterial = (materialId) => request.get(`/stock/material/${materialId}`)
export const getStockLogPage = (params) => request.get('/stock/log/page', { params })

// 租赁客户
export const getCustomerPage = (params) => request.get('/customer/page', { params })
export const getCustomerList = () => request.get('/customer/list')
export const getCustomerById = (id) => request.get(`/customer/${id}`)
export const addCustomer = (data) => request.post('/customer', data)
export const updateCustomer = (data) => request.put('/customer', data)
export const deleteCustomer = (id) => request.delete(`/customer/${id}`)

// 租赁合同
export const getRentalContractPage = (params) => request.get('/rental/contract/page', { params })
export const getRentalContractDetail = (id) => request.get(`/rental/contract/${id}`)
export const addRentalContract = (data) => request.post('/rental/contract', data)
export const updateRentalContract = (data) => request.put('/rental/contract', data)
export const confirmRentalContract = (id, data) => request.put(`/rental/contract/${id}/confirm`, data || {})
export const cancelRentalContract = (id) => request.put(`/rental/contract/${id}/cancel`)
export const deleteRentalContract = (id) => request.delete(`/rental/contract/${id}`)
export const getActiveRentalPage = (params) => request.get('/rental/contract/active/page', { params })
export const downloadContractItemTemplate = () => request.get('/rental/contract/item-template', { responseType: 'blob' })
export const importContractItems = (warehouseId, file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post(`/rental/contract/import-items?warehouseId=${warehouseId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000
  })
}

// 租赁归还
export const getRentalReturnPage = (params) => request.get('/rental/return/page', { params })
export const getRentalReturnDetail = (id) => request.get(`/rental/return/${id}`)
export const completeRentalReturn = (data) => request.post('/rental/return', data)
export const downloadReturnPlanTemplate = () => request.get('/rental/return/plan-template', { responseType: 'blob' })
export const checkReturnPlan = (contractId, file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post(`/rental/return/check-plan?contractId=${contractId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000
  })
}

export const getInboundPage = (params) => request.get('/inbound/page', { params })
export const getInboundDetail = (id) => request.get(`/inbound/${id}`)
export const addInbound = (data) => request.post('/inbound', data)
export const confirmInbound = (id) => request.put(`/inbound/${id}/confirm`)
export const deleteInbound = (id) => request.delete(`/inbound/${id}`)
export const downloadInboundDetailTemplate = () => request.get('/inbound/detail-template', { responseType: 'blob' })
export const importInboundDetails = (warehouseId, file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post(`/inbound/import-details?warehouseId=${warehouseId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000
  })
}

export const getOutboundPage = (params) => request.get('/outbound/page', { params })
export const getOutboundDetail = (id) => request.get(`/outbound/${id}`)
export const addOutbound = (data) => request.post('/outbound', data)
export const confirmOutbound = (id) => request.put(`/outbound/${id}/confirm`)
export const deleteOutbound = (id) => request.delete(`/outbound/${id}`)
export const downloadOutboundDetailTemplate = () => request.get('/outbound/detail-template', { responseType: 'blob' })
export const importOutboundDetails = (warehouseId, file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post(`/outbound/import-details?warehouseId=${warehouseId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000
  })
}
// RFID标签管理
export const getRfidTagPage = (params) => request.get('/rfid/tag/page', { params })
export const getRfidTagList = () => request.get('/rfid/tag/list')
export const getRfidTagsByMaterial = (materialId) => request.get(`/rfid/tag/material/${materialId}`)
export const getRfidTagByEpc = (epc) => request.get(`/rfid/tag/${epc}`)
export const addRfidTag = (data) => request.post('/rfid/tag', data)
export const updateRfidTag = (data) => request.put('/rfid/tag', data)
export const deleteRfidTag = (id) => request.delete(`/rfid/tag/${id}`)
export const bindRfidMaterial = (tagId, materialId) => request.put(`/rfid/tag/${tagId}/bind/${materialId}`)
export const unbindRfidMaterial = (tagId) => request.put(`/rfid/tag/${tagId}/unbind`)
export const getRfidTagIntakeSession = () => request.get('/rfid/tag/intake/session')
export const openRfidTagIntakeSession = (data) => request.post('/rfid/tag/intake/session/open', data || {})
export const closeRfidTagIntakeSession = () => request.post('/rfid/tag/intake/session/close')

// 系统管理
export const getSysUserPage = (params) => request.get('/system/user/page', { params })
export const addSysUser = (data) => request.post('/system/user', data)
export const updateSysUser = (data) => request.put('/system/user', data)
export const resetSysUserPassword = (id, password) => request.put(`/system/user/${id}/password`, { password })
export const deleteSysUser = (id) => request.delete(`/system/user/${id}`)
export const getSysRoleList = () => request.get('/system/role/list')
export const getMenuCatalog = () => request.get('/system/role/menus/catalog')
export const getRoleMenus = (roleCode) => request.get(`/system/role/${roleCode}/menus`)
export const saveRoleMenus = (roleCode, menuPaths) => request.put(`/system/role/${roleCode}/menus`, { menuPaths })

/** 公开品牌（登录页，平台租户） */
export const getPublicBranding = () => request.get('/auth/branding')
/** 公开 SaaS 开关（登录/注册页） */
export const getSaasConfig = () => request.get('/auth/saas-config')
/** 自助试用注册 */
export const selfRegister = (data) => request.post('/auth/register', data)
/** 当前登录租户品牌 */
export const getSystemBranding = () => request.get('/system/branding')
export const saveSystemBranding = (data) => request.put('/system/branding', data)
/** 开通租户（兼容旧路径） */
export const openTrialAccount = (data) => request.post('/system/branding/open-account', data)
export const getTenantPage = (params) => request.get('/system/tenant/page', { params })
export const freezeTenant = (id) => request.put(`/system/tenant/${id}/freeze`)
export const unfreezeTenant = (id) => request.put(`/system/tenant/${id}/unfreeze`)
export const cancelTenant = (id) => request.put(`/system/tenant/${id}/cancel`)
export const extendTenantTrial = (id, days) => request.put(`/system/tenant/${id}/extend-trial?days=${encodeURIComponent(days || 0)}`)
export const convertTenantStandard = (id) => request.put(`/system/tenant/${id}/convert-standard`)
